import { TitleCasePipe } from '@angular/common';
import { Component, input } from '@angular/core';
import { IdentityVerificationStatus, UserIdentityDto } from '@workspace/data-types';
import { GenderDisplayPipe } from '@workspace/ng-data-access';
import { LuxonDatePipe } from '../../../../pipes';
import { IdentityStatusComponent } from '../../../user/identity-status/identity-status.component';

@Component({
  selector: 'aura-person-identity-display',
  templateUrl: './person-identity-display.component.html',
  imports: [GenderDisplayPipe, TitleCasePipe, LuxonDatePipe, IdentityStatusComponent],
})
export class AuraPersonIdentityDisplayComponent {
  currentIdentity = input<UserIdentityDto | null>(null);
  showMode = input<'all' | 'names' | 'demographics'>('all');
  readonly Status = IdentityVerificationStatus;
}
